import React from 'react'
import PropTypes from 'prop-types'

import FontPreviewImageComponent from './_font_preview_image_component'

import GoogleAnalytics from '../../utils/googleAnalytics'

class FontPreviewComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = { text: this.props.itemName, delayTimer: null }
  }

  render () {
    const { fontFilenames, endpoint, itemId, version } = this.props
    const { text } = this.state

    let fontRenders

    if (fontFilenames.length > 0) {
      fontRenders = fontFilenames.map((filename, index) =>
        <div key={filename}>
          <FontPreviewImageComponent
            endpoint={endpoint}
            filename={filename}
            itemId={itemId.toString()}
            version={version && version.toString()}
            text={text} />
          {!(index === fontFilenames.length - 1) ? <hr className='h-hr' /> : null}
        </div>
      )
    } else {
      fontRenders = <FontPreviewImageComponent
        endpoint={endpoint}
        itemId={itemId.toString()}
        version={version && version.toString()}
        text={text} />
    }

    return (
      <div className='box e-box -radius-all h-mb2 h-p2'>
        <h1 className='t-heading -size-xs'>Test drive this font:</h1>
        <div className='h-mb2 h-mt2'>
          <input
            type='text'
            placeholder='Enter preview text'
            onChange={this._handleChange.bind(this)}
            onFocus={this._handleFocus.bind(this)}
            className='f-input -type-string'
            style={{ width: '100%' }}
            maxLength='100'
          />
        </div>
        {fontRenders}
      </div>
    )
  }

  componentWillUnmount () {
    clearTimeout(this.state.delayTimer)
  }

  _handleChange (event) {
    const inputText = event.target.value
    if (inputText === '') {
      this.setState({ text: this.props.itemName })
    } else {
      clearTimeout(this.state.delayTimer)
      this.setState({
        delayTimer: setTimeout(() => {
          this.setState({ text: inputText })
        }, 500)
      })
    }
  }

  _handleFocus (event) {
    GoogleAnalytics.sendEvent('event', 'fontpreview', 'focus', { label: this.props.itemId })
  }
}

FontPreviewComponent.propTypes = {
  endpoint: PropTypes.string.isRequired,
  itemId: PropTypes.string.isRequired,
  version: PropTypes.string.isRequired,
  itemName: PropTypes.string.isRequired,
  fontFilenames: PropTypes.arrayOf(PropTypes.string)
}

export default FontPreviewComponent
